import {AuthConfig} from 'angular-oauth2-oidc';
import { environment } from './../../environments/environment';



export const  authCodeFlowConfig:AuthConfig= {
        clientId: environment.clientId,
        redirectUri: environment.redirectUri, //changing redirect URI
        issuer: environment.issuer,
        
        strictDiscoveryDocumentValidation: false,
        // Use the same redirect URI as the main redirect for silent refresh
        // This ensures Azure AD redirects back to /ui for both normal auth and silent refresh
        // The app will detect if it's a silent refresh callback based on context (iframe + OAuth params)
        silentRefreshRedirectUri: environment.redirectUri,
        // Needed for Code Flow to suggest using iframe-based refreshes
        useSilentRefresh: true, 
        // Increased timeout for better reliability
        silentRefreshTimeout: 10000, 
        // For more reliable refresh
        timeoutFactor: 0.5, 
        // Hide iframe for better UX
        silentRefreshShowIFrame: false,
        sessionChecksEnabled: true,
        // Also requires enabling "Verbose" level in devtools
        showDebugInformation: false, 
        clearHashAfterLogin: false, 
        nonceStateSeparator : 'semicolon', 
        // Keep your backend API scope for main SSO token
        // We'll request Graph token separately using iframe
        scope: 'offline_access profile 2839b914-5970-4a0e-adaa-349ae4eb7bb1/.default',
        
        // Enable token response type for implicit flow (needed for iframe token acquisition)
        responseType: 'code',
        
        // Skip issuer validation to allow iframe redirects
        skipIssuerCheck: true,
  
  }




















